import React from 'react'
import {Button} from "antd";
import {useTranslations} from "../../lang";
import api from "../../api";
import {ExportOutlined} from "@ant-design/icons";

export default function OpenCropWebsiteButton({crop, size = 'default', label = true}) {

    const {translate} = useTranslations()

    function handleClick() {
        api.trackCropClick(crop.id)
        window.open(crop.url, '_blank');
    }

    if (!crop) {
        return null;
    }

    if (!crop.url) {
        return null;
    }

    let domain = "website"

    try {
        const hostname = new URL(crop.url).hostname;
        domain = hostname.replace(/^www\./, '');
    } catch (_) {
        return null;
    }

    return (
        <Button size={size} onClick={handleClick}>
            <ExportOutlined/> {label && (<>{translate('Bekijk op')} {domain}</>)}
        </Button>

    )
}